import React from 'react'
import styled, { css } from 'styled-components'
import { media } from 'utils/media'
import { HeaderTheme } from './layout/Header'

const Button = styled.button`
  appearance: none;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  z-index: 1001;
  padding: 20px 24px;

  ${media.phoneDown} {
    padding: 0px 16px;
  }
`

const Container = styled.div`
  width: 30px;
  height: 21px;
  position: relative;
  ${media.phoneDown} {
    height: 18px;
    width: 24px;
  }
`

const Bar = styled.div<{ open: boolean; theme: HeaderTheme }>`
  width: 30px;
  height: 3px;
  left: 0;
  background: ${(props) => (props.open ? 'white' : props.theme.foreground)};
  position: absolute;
  transform-origin: 0% 50%;
  transition: all 300ms ease-in-out;
  ${media.phoneDown} {
    width: 22.5px;
  }
`

const Top = styled(Bar)`
  top: 0;

  ${(props) =>
    props.open &&
    css`
      transform: rotate(45deg);
      left: 4px;
      top: -2px;
      ${media.phoneDown} {
        top: -1.5px;
      }
    `}
`

const Middle = styled(Bar)`
  top: 9px;
  opacity: 1;

  ${media.phoneDown} {
    top: 7px;
  }

  ${(props) =>
    props.open &&
    css`
      background: black;
      opacity: 0;
    `}
`

const Bottom = styled(Bar)`
  bottom: 0;

  ${(props) =>
    props.open &&
    css`
      transform: rotate(-45deg);
      left: 4px;
      bottom: -1px;
      ${media.phoneDown} {
        bottom: 0px;
      }
    `}
`

interface Props {
  open: boolean
  onClick: () => void
  headerTheme: HeaderTheme
}
export const Hamburger = ({ open, onClick, headerTheme }: Props) => (
  <Button onClick={onClick} aria-label={open ? 'Hide menu' : 'Show menu'}>
    <Container>
      <Top open={open} theme={headerTheme} />
      <Middle open={open} theme={headerTheme} />
      <Bottom open={open} theme={headerTheme} />
    </Container>
  </Button>
)
